import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import MobileStickyBar from '../components/common/MobileStickyBar';
import { Check, ArrowRight, AlertTriangle } from 'lucide-react';

const CHECKLIST_BAPTEME = [
  { cat: 'Cérémonie', items: ['Officiant et date confirmés', 'Tenue du bébé', 'Parrain / Marraine désignés', 'Textes et musique cérémonie', 'Livre d\'or préparé'] },
  { cat: 'Réception', items: ['Salle ou jardin réservé', 'Traiteur ou buffet familial', 'Gâteau baptême', 'Menu adapté (bébé + famille)', 'Boissons, flûtes champagne'] },
  { cat: 'Déco & Cadeaux', items: ['Décoration douce et élégante', 'Arche ballons blanc/or/rose', 'Bar à bonbons enfants', 'Faire-part envoyés', 'Cadeaux-souvenir invités'] },
  { cat: 'Photos & Souvenirs', items: ['Photographe réservé', 'Livre photos commandé', 'Album cadeau famille', 'Photos de groupe organisées'] },
];

export default function GuideBaptemePage() {
  const [checkItems, setCheckItems] = useState(
    CHECKLIST_BAPTEME.flatMap(c => c.items.map(item => ({ label: item, cat: c.cat, done: false })))
  );
  const progress = Math.round(checkItems.filter(i => i.done).length / checkItems.length * 100);

  return (
    <div style={{ background: 'var(--bg)', minHeight: '100vh' }}>
      <Header />

      {/* HERO */}
      <section className="relative overflow-hidden" style={{ minHeight: '50vh' }}>
        <img src="https://images.unsplash.com/photo-1731743215053-53eb81151f60?w=1400&q=85"
          alt="Baptême" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(11,30,32,0.85) 0%, rgba(11,30,32,0.45) 60%, transparent 100%)' }} />
        <div className="relative container-ose flex flex-col justify-end pb-12" style={{ minHeight: '50vh', paddingTop: '5rem' }}>
          <nav className="flex items-center gap-2 text-xs mb-4" style={{ color: 'rgba(255,255,255,0.6)' }}>
            <Link to="/guides" style={{ color: '#F4A7B2' }}>Guides</Link><span>/</span>
            <span style={{ color: '#FFF' }}>Baptême & Communion</span>
          </nav>
          <span className="inline-block w-fit px-4 py-2 rounded-full text-xs font-bold mb-4"
            style={{ background: 'rgba(244,167,178,0.2)', color: '#F4A7B2', border: '1px solid rgba(244,167,178,0.4)' }}>
            🕊️ Guide complet Baptême & Communion
          </span>
          <h1 className="font-display text-3xl sm:text-4xl font-bold mb-3"
            style={{ color: '#FFF', letterSpacing: '-0.03em', lineHeight: '1.1' }}>
            Organiser un baptême ou une communion inoubliable
          </h1>
          <p className="text-sm mb-6 max-w-xl" style={{ color: 'rgba(255,255,255,0.75)', lineHeight: '1.75' }}>
            Organisation cérémonie, réception famille, animations enfants, décoration douce et élégante.
          </p>
          <div className="flex flex-wrap gap-3">
            <a href="#checklist" className="inline-flex items-center gap-2 px-5 py-3 rounded-xl font-bold text-sm"
              style={{ background: '#F4A7B2', color: '#0B1E20' }}>
              <Check size={15} /> Checklist complète
            </a>
            <Link to="/creer-evenement" className="inline-flex items-center gap-2 px-5 py-3 rounded-xl font-semibold text-sm"
              style={{ background: 'rgba(255,255,255,0.12)', color: '#FFF', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.2)' }}>
              Créer mon devis <ArrowRight size={15} />
            </Link>
          </div>
        </div>
      </section>

      {/* PROGRESSION */}
      <div style={{ background: '#0B1E20', borderBottom: '1px solid rgba(244,167,178,0.2)' }}>
        <div className="container-ose py-3 flex items-center gap-4">
          <p className="text-xs font-semibold" style={{ color: '#F4A7B2' }}>{progress}% organisé</p>
          <div className="flex-1 h-2 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.1)' }}>
            <div className="h-full rounded-full" style={{ width: `${progress}%`, background: '#F4A7B2' }} />
          </div>
        </div>
      </div>

      {/* IDÉES DÉCO */}
      <section className="section-py section-white">
        <div className="container-ose">
          <div className="text-center mb-8">
            <h2 className="font-display text-2xl font-bold" style={{ color: 'var(--ink)' }}>Idées décoration 2026</h2>
          </div>
          <div className="grid sm:grid-cols-3 gap-4">
            {[
              { emoji: '🤍', theme: 'Blanc & Doré', desc: 'Élégant et intemporel — ballons blancs, guirlandes dorées, fleurs blanches' },
              { emoji: '🌸', theme: 'Rose Poudré & Naturel', desc: 'Doux et romantique — roses, eucalyptus, tons pastels' },
              { emoji: '💙', theme: 'Bleu Ciel & Blanc', desc: 'Classique et frais — pour un baptême garçon' },
            ].map((t, i) => (
              <div key={i} className="card-premium p-5 text-center">
                <div className="text-4xl mb-3">{t.emoji}</div>
                <p className="font-bold text-sm mb-1" style={{ color: 'var(--ink)' }}>{t.theme}</p>
                <p className="text-xs" style={{ color: 'var(--text-muted)', lineHeight: '1.6' }}>{t.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CHECKLIST */}
      <section id="checklist" className="section-py" style={{ background: 'var(--bg)' }}>
        <div className="container-ose">
          <div className="text-center mb-8">
            <h2 className="font-display text-2xl font-bold" style={{ color: 'var(--ink)' }}>Checklist organisation</h2>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            {CHECKLIST_BAPTEME.map(cat => {
              const catItems = checkItems.filter(i => i.cat === cat.cat);
              const done = catItems.filter(i => i.done).length;
              return (
                <div key={cat.cat} className="card-premium p-5">
                  <div className="flex items-center justify-between mb-3">
                    <p className="font-bold text-sm" style={{ color: 'var(--ink)' }}>{cat.cat}</p>
                    <span className="text-xs font-bold" style={{ color: '#F4A7B2' }}>{done}/{catItems.length}</span>
                  </div>
                  {catItems.map(item => (
                    <button key={item.label} onClick={() => setCheckItems(prev => prev.map(i => i.label === item.label && i.cat === item.cat ? { ...i, done: !i.done } : i))}
                      className="w-full flex items-start gap-2 p-1.5 rounded-lg text-left mb-1"
                      style={{ background: item.done ? 'rgba(244,167,178,0.06)' : 'transparent', border: 'none', cursor: 'pointer' }}>
                      <div className="w-4 h-4 rounded border-2 flex items-center justify-center flex-shrink-0 mt-0.5"
                        style={{ borderColor: item.done ? '#F4A7B2' : 'var(--border)', background: item.done ? '#F4A7B2' : 'transparent' }}>
                        {item.done && <Check size={9} color="white" />}
                      </div>
                      <span className="text-xs" style={{ color: item.done ? 'var(--text-muted)' : 'var(--ink)', textDecoration: item.done ? 'line-through' : 'none' }}>{item.label}</span>
                    </button>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-py" style={{ background: '#0B1E20' }}>
        <div className="container-ose text-center">
          <h2 className="font-display text-2xl font-bold mb-4" style={{ color: '#FFF' }}>Décoration et animations pour votre baptême</h2>
          <p className="text-sm mb-8 max-w-lg mx-auto" style={{ color: 'rgba(255,255,255,0.6)' }}>
            Arche ballons sur-mesure, bar à bonbons, décoration élégante — livraison et installation incluses.
          </p>
          <Link to="/creer-evenement"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-xl font-bold"
            style={{ background: '#F4A7B2', color: '#0B1E20' }}>
            Créer mon devis <ArrowRight size={18} />
          </Link>
        </div>
      </section>

      <Footer />
      <MobileStickyBar />
    </div>
  );
}
